import React from 'react'
import _ from 'common-tools/LodashHelper'
import { ah, sh, ReduxWrapper, compose, buildPropTypes, pt } from 'common-data/datahelpers'
import { Redirect } from '@reach/router'

class IndexRoutePlain extends React.Component {
  constructor (props) {
    super(props)
    const { routeAddIndexRoute, uri } = this.props
    if (uri) {
      routeAddIndexRoute(`${uri}`)
    }
  }

  static propTypes = buildPropTypes([

  ], {
    relativeRoutePeelBack: pt.number
  })

  static defaultProps = {
    relativeRoutePeelBack: 0
  }

  findRouteWithPermissions (items) {
    const { SessionAccount } = this.props

    for (var item of items) {
      let hasAccountAccess = true
      if (SessionAccount) {
        hasAccountAccess = SessionAccount.HasPermissions(item.permissions || [])
      }
      if (hasAccountAccess) {
        if (item.link) {
          return item
        }
      }
      if (_.isArray(item.children) === true) {
        let childRoute = this.findRouteWithPermissions(item.children)
        if (childRoute) {
          return childRoute
        }
      }
    }

    return null
  }

  render () {
    const { items, navigate, defaultRoute } = this.props

    const firstRoute = this.findRouteWithPermissions(items)

    if (defaultRoute) {
      return <Redirect noThrow from='/' to={defaultRoute} />
    } else {
      if (!firstRoute || !firstRoute.link) {
        return <p>Looks like you do not have access to any of these menus!</p>
      } else {
        return <Redirect noThrow to={firstRoute.link} />
      }
    }
  }
}

export const IndexRoute = compose(
  ReduxWrapper([
    sh.SessionAccount
  ], [
    ah.routeAddIndexRoute
  ])
)(IndexRoutePlain)
